import React, { type FC } from "react";
import type { ApiSpMovingData } from "@src/businessModules/Stock/api/storePlaces";
import { BusinessDateValue } from "@src/components/business-data-display";
import { DetailList, DetailRow } from "@shared/ui/detail-row";
import "./StockPlacementCancelConfirmContent.scss";

/** Поле confirm-контента отмены размещения. */
export interface StockPlacementCancelConfirmField {
    /** Подпись поля. */
    label: string;
    /** Значение поля. */
    value?: string | null;
}

/** Пропсы компонента {@link StockPlacementCancelConfirmContent}. */
export interface StockPlacementCancelConfirmContentProps {
    /** Движение, которое будет удалено при подтверждении. */
    movement: ApiSpMovingData;
    /** Поля контекста строки состава. */
    fields: StockPlacementCancelConfirmField[];
}

/** Domain-контент confirm для отмены размещения партии. */
export const StockPlacementCancelConfirmContent: FC<StockPlacementCancelConfirmContentProps> = ({ movement, fields }) => {
    return (
        <div className="stock_placement_cancel_confirm_content">
            <p className="stock_placement_cancel_confirm_content__message">Будет удалено последнее движение размещения:</p>
            <section
                className="stock_placement_cancel_confirm_content__section"
                aria-labelledby="stock-placement-cancel-confirm-details-title"
            >
                <h3
                    id="stock-placement-cancel-confirm-details-title"
                    className="stock_placement_cancel_confirm_content__section_title"
                >
                    Движение
                </h3>
                <DetailList
                    layout="tiles"
                    columns="auto"
                    minWidth={80}
                    className="stock_placement_cancel_confirm_content__details"
                >
                    <DetailRow label="Код движения" value={String(movement.Code)} />
                    <DetailRow label="Количество" value={String(movement.Qty)} />
                    <DetailRow label="Дата" value={<BusinessDateValue value={movement.UserDate} preset="dateTime" />} />
                    {fields.map((row) => (
                        <DetailRow key={row.label} label={row.label} value={row.value ?? "—"} />
                    ))}
                </DetailList>
            </section>
        </div>
    );
};
